import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzBadgeComponent } from 'ng-zorro-antd/badge';
import { IconComponent } from '../../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-needs-review-state',
  standalone: true,
  imports: [CommonModule, NzBadgeComponent, IconComponent],
  templateUrl: './needs-review-state.component.html',
  styleUrl: './states.component.less',
})
export class NeedsReviewStateComponent {
}
